import { render } from "./RecentProjects.vue?vue&type=template&id=6e12a211&ts=true"
import script from "./RecentProjects.vue?vue&type=script&lang=ts"
export * from "./RecentProjects.vue?vue&type=script&lang=ts"

import "./RecentProjects.vue?vue&type=style&index=0&id=6e12a211&lang=scss"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__